export type OverlayTemplateLibraryMode =
  | 'account'
  | 'profileGroup'
  | 'accountPicker';

export type OverlayTemplateSortValue =
  | 'newest'
  | 'oldest'
  | 'nameAsc'
  | 'nameDesc';

export type OverlayTemplateLibraryCategory = 'all' | 'shared' | 'mine';

export type OverlayTemplateFolderLibrary = 'shared' | 'mine';

export type OverlayTemplateLibrarySelection =
  | OverlayTemplateLibraryCategory
  | `folder:${string}`
  | `${OverlayTemplateFolderLibrary}-folder:${string}`;

export const getOverlayTemplateFolderId = (
  selection: OverlayTemplateLibrarySelection
): string | null => {
  const separator = '-folder:';
  if (selection.startsWith('folder:')) return selection.slice('folder:'.length);
  if (selection.startsWith(`shared${separator}`))
    return selection.slice(`shared${separator}`.length);
  if (selection.startsWith(`mine${separator}`))
    return selection.slice(`mine${separator}`.length);
  return null;
};

export const getOverlayTemplateFolderLibrary = (
  selection: OverlayTemplateLibrarySelection
): OverlayTemplateFolderLibrary | null => {
  if (selection === 'shared' || selection.startsWith('shared-folder:'))
    return 'shared';
  if (selection === 'mine' || selection.startsWith('mine-folder:'))
    return 'mine';
  return null;
};

export const getOverlayTemplateFolderSelection = (
  library: OverlayTemplateFolderLibrary,
  folderId: string
): OverlayTemplateLibrarySelection => `${library}-folder:${folderId}`;

export interface OverlayTemplateSummary {
  id: string;
  title: string;
  thumbnailUrl?: string | null;
  aspectRatio: string;
  folderId?: string | null;
  isShared: boolean;
}

export interface OverlayTemplateFolder {
  id: string;
  name: string;
}

export interface OverlayTemplateSortOption {
  value: OverlayTemplateSortValue;
  label: string;
}

export interface OverlayTemplateCardLabels {
  shared: string;
  sharedOverlay: string;
  edit: string;
  changeFolder: string;
  duplicate: string;
  delete: string;
  startPost: string;
  thumbnailLoading: string;
  thumbnailUnavailable: string;
}
